module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', {
    staticClass: "reveal"
  }, [_vm._v("\n        © 2018 djaduls, made with lots of ❤️ and steaming hot ☕️.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "reveal"
  }, _vm._l((_vm.social), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "icon",
      attrs: {
        "href": item.link,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_c('b-icon', {
      attrs: {
        "icon": item.icon
      }
    })], 1)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdeca308"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 548
// module chunks = 1